import { RadioGroup as BaseRadioGroup } from '@toolbox/components';
import { useField } from '@toolbox/form';
import { useStepContext } from '@widget/core';

import type { RadioGroupProps as BaseRadioGroupProps } from '@toolbox/components';

export type RadioGroupFieldProps<T> = Omit<BaseRadioGroupProps<T>, 'value'> & {
  submit?: boolean;
};

export function RadioGroupField<T>(props: RadioGroupFieldProps<T>): JSX.Element {
  const { submit } = useStepContext();
  const {
    field: { ref, ...field },
  } = useField({ name: props.name, defaultValue: props.defaultValue || null });

  const handleChange = (value: T): void => {
    field.onChange(value);

    if (props.submit) {
      setTimeout(submit, 0);
    }
  };

  return <BaseRadioGroup<T> {...props} {...field} onChange={handleChange} />;
}
